import { type FunctionComponent, useEffect, useState } from "react";
import { onlineProviders } from "@/react/OnlineOrderSettingView/OnlineProviderSettingView.logic";
import {
  filtersDelivery, PLATFORM,
  setFiltersDelivery,
  setFilterV
} from "@/react/DeliveryManagementView/DeliveryManagementLogic.tsx";
import clsx from "clsx";
import { LL0 } from "@/react/core/I18nService";

interface SearchPlatformProps {
  onClose?: () => void
}

const SearchPlatform: FunctionComponent<SearchPlatformProps> = ({ onClose }) => {
  const [providers, setProviders] = useState<string[]>(filtersDelivery()?.providers || []);
  useEffect(() => {
    if (filtersDelivery()?.providers) {
      console.log('providers:', filtersDelivery().providers);
      setProviders(filtersDelivery()?.providers)
    }
  }, []);
  return (
    <div className="w-[524px] h-auto font-mulish overflow-hidden rounded-[8px] bg-white">
      <div className="flex flex-1  px-3 py-2 rounded-t-[8px] border-b border-[#e0e0e0]">
        <div className="flex-1 font-bold text-[16px] text-[#0051c1]">
          {LL0().order.search() + ' ' + LL0().deliveryManagement.platform().toLocaleLowerCase()}
        </div>
        <img src="/icon-close-popup-icon--grey@2x.png" className="w-[22px] h-[22px]" alt="" onClick={onClose} />
      </div>
      <div className="flex flex-wrap gap-2 p-3">
        <div
          onClick={() => {
            let filterProviders = filtersDelivery()?.providers || [];
            if (filterProviders.includes('phone')) {
              filterProviders = filterProviders.filter(id => id !== 'phone');
            } else {
              console.log('push ', 'phone');
              filterProviders.push('phone');
            }
            const newFilters = { ...filtersDelivery(), providers: filterProviders };
            setProviders(filterProviders);
            setFiltersDelivery(newFilters);
            setFilterV(p => p + 1)
          }}
          className={clsx("p-2 gap-[6px] border flex items-center rounded-[4px] w-[160px]",
            providers?.includes("phone") ? "border-[#90caf9] bg-[#e3f2fd]" : "border-[#bcbcbc] bg-[#ffffff]"
            )}
        >
          <img src={PLATFORM["phone"].icon} className="w-6" alt=""/>
          <span className="font-semibold text-[14px]">{PLATFORM["phone"].name}</span>
        </div>
        {onlineProviders().filter(o => o.isEnabled).map(o => (
          <div
            key={o._id}
            onClick={() => {
              let filterProviders = filtersDelivery()?.providers || [];
              if (filterProviders.includes(o._id)) {
                filterProviders = filterProviders.filter(id => id !== o._id);
              } else {
                console.log('push ', o._id);
                filterProviders.push(o._id);
              }
              const newFilters = { ...filtersDelivery(), providers: filterProviders };
              setProviders(filterProviders);
              setFiltersDelivery(newFilters);
              setFilterV(p => p + 1)
            }}
            className={clsx(
              "p-2 gap-[6px] border flex items-center rounded-[4px] w-[160px]",
              {
                "border-[#90caf9] bg-[#e3f2fd]": providers?.includes(o._id),
                "border-[#bcbcbc] bg-[#ffffff]": !providers?.includes(o._id)
              }
            )}
          >
            {Object.keys(PLATFORM).includes(o.name) ?
              <img src={PLATFORM[o.name].icon} className="w-6" alt=""/>
              : null
            }
            <span className="font-semibold text-[14px]">{o.name}</span>
          </div>
        ))}
      </div>
    </div>
  )
}

export default SearchPlatform;